const getDefaultState = () => ({
    contacts: [],
});

const state = () => getDefaultState();

const getters = {
    memberCount: (state) => state.contacts.length,
    contactList: (state) => state.contacts,
};

const actions = {
    contactCreated({ commit }, payload) {
        commit('addContact', payload);
        return { status: 'success', message: payload };
    },
    setContacts({ commit }, contacts) {
        commit('setContacts', contacts);
    },
    resetContactsState({ commit }) {
        commit('resetState');
    },
};

const mutations = {
    addContact(state, payload) {
        const newContact = { ...payload, contactId: state.contacts.length + 1 };
        state.contacts.push(newContact);
    },
    setContacts(state, contacts) {
        state.contacts = Array.isArray(contacts) ? contacts : [];
    },
    resetState(state) {
        Object.assign(state, getDefaultState());
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
